let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("erM4f")).then(() => parcelRequire('fEvxc'));